import React from 'react';
import { XCircle, AlertCircle } from 'lucide-react';
export function ProblemAgitation() {
  return <section className="py-16 bg-accent-creamDark" data-id="element-106">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="text-center mb-12" data-id="element-108">
          <h2 className="md:text-4xl text-secondary mb-4 text-[32px] font-[700]" data-id="element-109">
            ¿Te pasa esto… aunque "te prometes" que hoy sí?
          </h2>
          <div className="w-24 h-1 bg-accent-coral mx-auto rounded-full" data-id="element-110"></div>
        </div>

        {/* Pain Points */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 mb-12 border border-gray-100" data-id="element-111">
          <ul className="space-y-6" data-id="element-112">
            {["A las 4 pm tu pecho se aprieta y 'necesitas' algo dulce para seguir", 'Comes el dulce y a los 10 minutos llega la culpa y el bajón de energía', 'Sientes que te inflamas, te aprieta la ropa y te da neblina mental', 'Has intentado dejarlo a la fuerza… y vuelves peor en la noche'].map((point, i) => <li key={i} className="flex items-start" data-id="element-113">
                <XCircle className="h-6 w-6 text-red-500 flex-shrink-0 mr-4 mt-1" data-id="element-114" />
                <span className="text-lg text-gray-700 font-medium" data-id="element-115">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Transition/Empathy */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-116">
          <p className="text-xl md:text-2xl font-medium text-secondary leading-relaxed" data-id="element-117">
            Si te reconoces,{' '}
            <span className="text-primary font-bold" data-id="element-118">no eres débil</span>: estás
            peleando contra un secuestro hormonal. Por eso este reset no se basa
            en fuerza de voluntad.
          </p>
        </div>

        {/* Why Typical Fails */}
        <div className="bg-red-50 border border-red-100 rounded-xl p-6 md:p-8" data-id="element-119">
          <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center justify-center gap-2" data-id="element-120">
            <AlertCircle className="h-6 w-6" data-id="element-121" />
            Por qué lo típico falla
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-122">
            {[{
            title: 'Dejarlo de golpe',
            desc: 'Dispara malestar y rebote inmediato'
          }, {
            title: 'Edulcorantes',
            desc: 'Generan más hambre y más ansiedad'
          }, {
            title: 'Dietas extremas',
            desc: 'Estrés, cortisol y atracones nocturnos'
          }].map((item, i) => <div key={i} className="text-center" data-id="element-123">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-red-500 font-bold text-xl border border-red-100" data-id="element-124">
                  {i + 1}
                </div>
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-125">{item.title}</h4>
                <p className="text-sm text-gray-600" data-id="element-126">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}